import React from "react"

import NotFoundPage from "../NotFoundPage"

const DashboardRoute = () => <NotFoundPage />

export default DashboardRoute
